import { Info } from "lucide-react";
import type * as React from "react";
import { Tooltip } from "@/components/ui/misc";

/** A one-line hint, with the rest of the explanation behind an info icon. */
export function Hint({ children, more }: { children: React.ReactNode; more: string }) {
  return (
    <>
      {children}{" "}
      <Tooltip content={more}>
        <button
          type="button"
          aria-label={more}
          className="inline-flex translate-y-0.5 text-text-subtle hover:text-text"
        >
          <Info className="size-3" />
        </button>
      </Tooltip>
    </>
  );
}
